import { motion } from "framer-motion";
import { _TEST1234 } from "../../config/ApiConfig";

export const LoginHeaderImage = () => {
    switch (_TEST1234.SYSTEM_GROUP_ORI) {
        case "tancis":
        case "tanesw":
            return (
                <div className="absolute w-full h-full top-0 left-0 sm:hidden">
                    <motion.img
                        src={process.env.PUBLIC_URL + "/imgs/img_airplane.svg"}
                        className="absolute top-0 left-0 will-change-transform"
                        initial={{ translateX: "-110%", translateY: "-50%" }}
                        animate={{ translateX: "-50%", translateY: "-25%" }}
                        transition={{ duration: 0.8 }}
                        alt="login background image airplane"
                        title="login background image airplane"
                        width={101}
                        height={107}
                    />
                    <img
                        src={process.env.PUBLIC_URL + "/imgs/img_ship.svg"}
                        className="absolute right-0 bottom-0 translate-x-1/4 translate-y-[15%]"
                        alt="login background image ship"
                        title="login background image ship"
                        width={250}
                        height={178}
                    />
                </div>
            );
        case "tanoga":
            return (
                <div className="absolute w-full h-full top-0 left-0 sm:hidden">
                    <img
                        src={process.env.PUBLIC_URL + "/imgs/login_building.svg"}
                        className="absolute right-0 bottom-0 translate-x-1/4 translate-y-[15%]"
                        alt="login image buildings"
                        title="login image buildings"
                        width={166}
                        height={167}
                    />
                </div>
            );
        default:
            return null;
    }
};
